module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": _vm.svgSize,
      "height": _vm.svgSize
    }
  }, [_c('g', {
    attrs: {
      "transform": _vm.transform
    }
  }, [_c('path', {
    staticClass: "star",
    attrs: {
      "d": _vm.starPath,
      "stroke": _vm.backColor,
      "fill": _vm.backColor
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "circle",
    attrs: {
      "d": _vm.circlePath,
      "stroke": _vm.frontColor,
      "fill": _vm.backColor
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "line",
    attrs: {
      "d": _vm.linePath,
      "stroke": _vm.frontColor
    }
  }), _vm._v(" "), _c('text', {
    staticClass: "mark",
    attrs: {
      "x": 11.0,
      "y": 11.5,
      "fill": _vm.frontColor
    }
  }, [_vm._v(_vm._s(_vm.mark))]), _vm._v(" "), _c('text', {
    staticClass: "mark",
    attrs: {
      "x": 12.5,
      "y": 19.0,
      "fill": _vm.frontColor
    }
  }, [_vm._v("10")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35c67e9d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/nutrieduc/Badge.vue
// module id = 1182
// module chunks = 1